import script from "./DateFieldDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateFieldDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./DateFieldDrawer.vue?vue&type=style&index=0&id=297a83d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-297a83d6"]])

export default __exports__